'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _electronUpdateSelector = require('./electronUpdateSelector');

var _electronUpdateSelector2 = _interopRequireDefault(_electronUpdateSelector);

require('./ElectronAppUpdateNotify.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElectronAppUpdateNotify = function ElectronAppUpdateNotify(_ref) {
    var updateReady = _ref.updateReady;

    if (!updateReady) return null;

    return _react2.default.createElement('div', { className: 'ElectronAppUpdateNotify' });
};

ElectronAppUpdateNotify.propTypes = {
    updateReady: _react2.default.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(_electronUpdateSelector2.default)(ElectronAppUpdateNotify);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/electronApp/ElectronAppUpdateNotify.js
// module id = 2174
// module chunks = 0